<template>
  <div class="form-group">
    <label :for="id" class="control-label">Add characteristics</label>
    <CharacteristicsTypeahead :id="id" @selected="addCharacteristic" />
    <ul class="list-group">
      <li
        class="list-group-item"
        v-for="(s, index) of selectedInternal"
        :key="s">
        <span>
          <template>{{ characteristicsMap[s] && characteristicsMap[s].Label || s }}</template>
        </span>
        <button
          class="remove text-danger"
          role="button"
          :aria-label="`Remove characteristic ${characteristicsMap[s] && characteristicsMap[s].Label || s}`"
          @click="remove(index)">
          <i class="fa fa-times"/>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
import CharacteristicsTypeahead from './CharacteristicsTypeahead'

export default {
  name: 'SelectCharacteristics',
  components: { CharacteristicsTypeahead },
  props: {
    id: {
      type: String,
      required: true
    },
    selected: {
      type: Array,
      default: () => []
    },
    characteristicsMap: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      selectedInternal: this.selected || []
    }
  },
  methods: {
    addCharacteristic(uuid) {
      if (!uuid || this.selected.includes(uuid)) {
        return
      }
      this.selectedInternal = [...this.selectedInternal, uuid]
      this.$emit('update:selected', this.selectedInternal)
      this.$emit('add', uuid)
    },
    remove(i) {
      this.selectedInternal.splice(i, 1)
      this.$emit('update:selected', [...this.selectedInternal])
    },
    sequenceChanged(evt) {
      if (evt.moved) {
        this.$emit('update:selected', [...this.selectedInternal])
      }
    }
  },
  watch: {
    selected(newValue) {
      this.selectedInternal = newValue || []
    }
  }
}
</script>

<style lang="less" scoped>
.input-group {
  margin-bottom: 1em;
}
.list-group-item {
  display: flex;
  span {
    flex: 1 1 auto;
  }
  .remove {
    flex: 0 0 auto;
  }
}
</style>
